import { features } from '@/mocks/home';

export default function FeaturesSection() {
  return (
    <section id="features" className="w-full py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-3">
            为什么选择香蕉视频？
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            六大核心优势，为你带来前所未有的短视频体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {features.map((feature, idx) => (
            <div
              key={idx}
              className="group bg-background-50 rounded-2xl p-6 md:p-7 transition-all duration-300 hover:scale-[1.02] border border-background-200/60"
            >
              <div className="w-12 h-12 rounded-xl bg-primary-100 flex items-center justify-center mb-4 group-hover:bg-primary-500 transition-colors duration-300">
                <i className={`${feature.icon} text-xl text-primary-500 group-hover:text-white transition-colors duration-300`}></i>
              </div>
              <h3 className="font-heading text-lg text-foreground-950 mb-2">{feature.title}</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}